import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { AffectedStaffYouthsRating } from './types'

export function getAffectedStaffYouthsRating(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.getEndOfJourneyReview.url, {
        id: affectedStaffId
      })
    )
    .get<AffectedStaffYouthsRating>()
}
